import React from 'react';
import FullInfoField from 'components/FullInfoField/FullInfoField';

interface IProps {
	tlsCertificateName: Nullable<string>;
}

export const TlsCertificateNameFromRestaurant: React.FC<IProps> = ({ tlsCertificateName }) => {
	return <FullInfoField label="tlsCertificateNameLabel" value={tlsCertificateName} />;
};
